import React from 'react';
import { Card, Spin, Alert, Space } from 'antd';
import { Typography } from 'antd';

const { Text } = Typography;

/**
 * SourcePreflightDetails component that displays preflight details in SourceInformation
 * @param {Object} preflightData - Preflight data from API
 * @param {boolean} isLoading - Loading state
 * @param {Object} error - Error state
 */
export const SourcePreflightDetails = ({ preflightData, isLoading, error }) => {
    if (isLoading) {
        return (
            <Card title="Preflight Details" size="small" style={{ marginTop: '16px' }}>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Spin size="small" />
                    <div style={{ marginTop: '8px', color: '#666' }}>Loading preflight details...</div>
                </div>
            </Card>
        );
    }

    if (error) {
        return (
            <Card title="Preflight Details" size="small" style={{ marginTop: '16px' }}>
                <Alert title="Failed to load preflight details" type="error" size="small" />
            </Card>
        );
    }

    if (!preflightData?.content) {
        return null;
    }

    // Group errors and warnings by preflight check
    const failedChecks = preflightData.content.filter((check) => check.errors && check.errors.length > 0);

    if (failedChecks.length === 0) {
        return null;
    }

    return (
        <Card style={{ marginTop: '16px' }}>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <Space orientation="vertical" style={{ width: '100%' }} size="middle">
                    {failedChecks.map((check, index) => {
                        const checkType = check.error_type === 'warning' ? 'warning' : 'error';

                        return (
                            <Alert
                                key={index}
                                type={checkType}
                                showIcon
                                title={
                                    <Text strong style={{ fontSize: '13px' }}>
                                        {check.label || check.name} ({checkType.toUpperCase()})
                                    </Text>
                                }
                                description={
                                    <div>
                                        {check.errors.map((error, errorIndex) => (
                                            <div
                                                key={errorIndex}
                                                style={{
                                                    fontSize: '12px',
                                                    lineHeight: '1.5',
                                                    marginBottom: errorIndex < check.errors.length - 1 ? '8px' : '0',
                                                }}
                                            >
                                                • {error.message}
                                            </div>
                                        ))}
                                    </div>
                                }
                            />
                        );
                    })}
                </Space>
            </div>
        </Card>
    );
};
